import React from "react";
import { motion } from "framer-motion";
import { Code2, Layers, Wrench, Database, Cpu, FileCode2, Layout } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { skillGroups } from "../data/mock";

const iconMap = { Code2, Layers, Wrench, Database, Cpu, Layout };

const accentByCat = {
  languages: "cyan",
  backend: "amber",
  frontend: "emerald",
  "data & messaging": "cyan",
  "devops & tools": "emerald",
  fundamentals: "amber",
};
const accentText = {
  cyan: "text-cyan-300",
  amber: "text-amber-300",
  emerald: "text-emerald-300"
};
const accentBorder = {
  cyan: "border-cyan-400/30",
  amber: "border-amber-400/30",
  emerald: "border-emerald-400/30"
};

const DependencyBlock = ({ group, index }) => {
  const Icon = iconMap[group.icon] || Code2;
  const accent = accentByCat[group.category] || "cyan";
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: index * 0.07 }}
      whileHover={{ y: -3 }}
      className="relative rounded-xl overflow-hidden glass-strong hover:border-white/15 transition-all"
    >
      <div className="flex items-center gap-2 h-9 px-4 border-b border-white/5 bg-[#0a0b10]">
        <Icon className={`w-3.5 h-3.5 ${accentText[accent]}`} />
        <span className="font-mono text-[11px] text-zinc-400">
          {group.artifact}.xml
        </span>
      </div>
      <div className="p-4 font-mono text-[12px] leading-relaxed">
        <div className="text-zinc-600">
          &lt;<span className={accentText[accent]}>dependencies</span>&gt;
        </div>
        {group.items.map((item) => (
          <div key={item} className="pl-4 text-zinc-300 group">
            <span className="text-zinc-600">&lt;</span>
            <span className="text-cyan-300">dep</span>
            <span className="text-zinc-600">&gt;</span>
            <span className={`ml-1 ${accentText[accent]} group-hover:underline decoration-dotted`}>
              {item}
            </span>
            <span className="text-zinc-600">&lt;/</span>
            <span className="text-cyan-300">dep</span>
            <span className="text-zinc-600">&gt;</span>
          </div>
        ))}
        <div className="text-zinc-600">
          &lt;/<span className={accentText[accent]}>dependencies</span>&gt;
        </div>
      </div>
    </motion.div>
  );
};

const Skills = () => {
  return (
    <section
      id="skills"
      className="relative py-24 md:py-32 bg-gradient-to-b from-transparent via-cyan-950/[0.04] to-transparent"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading
          eyebrow="Dependencies"
          title="Stack I import daily."
          description="If my portfolio had a pom.xml — this would be it."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {skillGroups.map((g, i) => (
            <DependencyBlock key={g.category} group={g} index={i} />
          ))}
        </div>

        {/* Footer note */}
        <div className="mt-8 flex items-center gap-2 text-zinc-500">
          <FileCode2 className="w-3.5 h-3.5" />
          <span className="font-mono text-[11px]">
            all dependencies up-to-date — last resolved on this page load
          </span>
        </div>
      </div>
    </section>
  );
};

export default Skills;
